<template>
    <div id="shareHandWrite">
        <el-dialog
                title="板书分享"
                :visible.sync="show_dialog"
                width="80%"
                :modal-append-to-body="!can_click_close"
                :append-to-body="!can_click_close"
                :close-on-click-modal="can_click_close" @close="handleClose">
            <div class="dialog-content" slot="">
            </div>
            <div class="save-to-position">
                <span><i>*</i>科目课时</span>
                <selectCourse @selectCourse="selectCourseFun" :click-type="click_type"></selectCourse>
            </div>
            <div class="save-to-position">
                <span><i>*</i>授课班级</span>
                <!--学科选择框-->
                <el-select v-model="cur_class_id" placeholder="请选择班级" size="small" multiple @change="select_class">
                    <el-option
                            v-for="(item,index) in class_list"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
<!--                <p v-if="cur_class_id.length==0">请选择要分享的班级</p>-->
            </div>
            <div class="dialog-bottom">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="primary" @click="sure_share" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import selectCourse from './selectCourse'
    import {teaShareBord, addFileBord, getClass,default as api} from '../indexApi'
    export default {
        name: "shareHandWrite",
        props:{
            curImgUrl:{
                type:String,
                default(){
                    return ''
                }
            },
            bgFileId: {
              type: String,
              default() {
                return '';
              },
            },
            canvasSet:{
                type:Object,
                default(){
                    return {}
                }
            },
            isSave:{
                type:Boolean,
                default(){
                    return false
                }
            },
            classList:{
                type:Array,
                default(){
                    return []
                }
            },
            itemId:{
                type:String,
                default(){
                    return null
                }
            },
        },
        data(){
            return{
                click_type:1,
                show_dialog:true,//是否显示对话框
                can_click_close:false,//点击遮罩层关闭
                hand_write_name:'',//板书名称
                cur_select_course:{},
                class_list:this.classList.slice(1)||[],
                cur_class_id:[],
                select_course_obj:{},
                root_subject_id:'',
            }
        },
        components:{
            selectCourse,//选择课时
        },
        methods:{
            //关闭保存弹窗
            handleClose(done) {
                this.show_dialog = false ;
                if(this.isSave){
                    this.$emit('sureShare',false)
                }else{
                    this.show_dialog = false ;
                    this.$emit('sureShare',true)
                }
            },
            sure_share(){
                if(this.cur_select_course.id<=0 || !this.select_course_obj.subject_id){
                    this.$message({
                        message:'请选择要分享的课程',
                        type:'warning'
                    });
                    return;
                }
                //是否是保存之后的分享
                if(this.isSave){
                    if(this.cur_class_id.length==0){
                        this.$message.error('请选择分享的班级')
                        return;
                    }
                    this.teaShareBord(this.itemId);
                }else{
                    this.uploadFile_copy('6',this.dataURLtoBlob(this.curImgUrl),this.addFileBord)
                }
            },
            //保存板书
            addFileBord(data){
                let bg_file_cdn_id = this.bgFileId;

                if (this.canvasSet.back.toLowerCase().replace(/\s+/g, '') !== 'rgba(255,255,255,0)') {
                  bg_file_cdn_id = '';
                }

                addFileBord({
                    title:this.hand_write_name,
                    course_id:this.cur_select_course.id,
                    class_id:sessionStorage.getItem('class'),
                    file_cdn_id:data.file_cdn_id,
                    bg_file_cdn_id: bg_file_cdn_id || null,
                    bg_color:this.canvasSet.back
                }).then((res)=>{
                    if(res.errCode==0){
                        this.teaShareBord(res.data.id);
                        // this.show_dialog = false ;
                        // this.show_dialog = false;
                        // this.$emit('sureShare', this.cur_select_course);
                        // this.$emit('saveBord',true)
                        // console.log(res.data)
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(err=>console.log(err))
            },
            teaShareBord(id){
                teaShareBord({
                    id:id,
                    course_id:this.select_course_obj.subject_id?this.select_course_obj.subject_id.id:'',
                    class_ids:this.cur_class_id,
                    // ids:[id],
                }).then((res)=>{
                    if(res.errCode==0){
                        this.$flydata.flydataTrack(72);
                        if(res.data.not_push_class_ids.length>0){
                            let not_push_class = ''
                            res.data.not_push_class_ids.forEach((item,index)=>{
                                this.class_list.forEach((class_item)=>{
                                    if(item==class_item.id){
                                        not_push_class += (class_item.name +'、')
                                    }
                                })
                            })
                            not_push_class = not_push_class.slice(0,-1)
                            this.$message({
                                message:`${not_push_class}该课未推送，学生可在推送后看到该板书`,
                                type:'warning'
                            });
                        }else{
                            this.$message({
                                message:'分享成功，学生可在【板书分享】看到该板书',
                                type:'success'
                            });
                        }
                        if(this.isSave){
                            this.show_dialog = false ;
                            this.$emit('sureShare',true)
                        }else{
                            this.show_dialog = false ;
                            this.$emit('sureShare',false)
                        }
                        // console.log(res.data)
                    }
                }).catch(err=>console.log(err))
            },
            //
            selectCourseFun(val){
                this.select_course_obj = _.cloneDeep(val)
                this.cur_select_course = _.cloneDeep(val);
                if(this.root_subject_id != val.root_subject_id ){
                    this.getClass();
                }
                this.root_subject_id = val.root_subject_id ;
            },
            getClass(){
                getClass({
                    root_subject_id:this.select_course_obj.root_subject_id||sessionStorage.getItem('root_subject')
                }).then((res)=>{
                    if(res.errCode==0){
                        this.class_list = _.cloneDeep(res.data);
                        let index = this.class_list.findIndex((e)=>{return  e.id == sessionStorage.getItem('class')})

                        if(index>-1){
                            this.cur_class_id = [sessionStorage.getItem('class')]
                        }else{
                            this.cur_class_id = []
                        }
                    }
                }).catch(err=>{console.log(err)})
            },
            select_class(val){


            },
        },
        created(){
            let now_year=new Date().getFullYear().toString();
            let now_month= (new Date().getMonth()+1)<10?'0'+ (new Date().getMonth()+1):(new Date().getMonth()+1).toString();
            let now_date= new Date().getDate()<10?'0'+ (new Date().getDate()):(new Date().getDate()).toString();
            let now_time= now_year+now_month+now_date ;
            this.hand_write_name = '板书'+now_time ;
            if(!this.isSave){
                this.getClass();
            }
        },
    }
</script>

<style scoped lang="scss">
#shareHandWrite{


}
.save-to-position{
    margin-bottom:0.2rem;
    >span{
        display: inline-block;
        width:1rem;
        font-size: 0.16rem;
        text-align: right;
        padding-right:0.15rem;
        i{
            vertical-align: middle;
            color:red;
            margin-right:0.04rem;
        }
    }
    >p{
        display: inline-block;
        color:red;
        margin-left: 0.3rem;
        font-size: 0.14rem;
    }
}
/deep/.el-dialog{
    border-radius: 4px;
    max-width: 9rem;
    min-width: 6rem;
}
/deep/.el-dialog__header{
    font-weight: 500;
    color: #202020;
    padding: 0.16rem 0.16rem 0 0.3rem;
}
/deep/.el-dialog__headerbtn .el-dialog__close{
    font-size: 0.18rem;
    font-weight: bold;
}
.dialog-bottom{
    text-align: right;
    padding-top:0.2rem;
    .el-button{
        height: 0.34rem;
        width: 0.72rem;
        &:last-of-type{
             margin-left: 0.2rem;
         }
    }
}
</style>
